import React, { useState } from 'react';
import { NavLink, useNavigate, useLocation } from 'react-router-dom';
import { useAuth } from '../../context/AuthContext';
import {
  FaChartBar, FaFileInvoice, FaArrowUp, FaArrowDown,
  FaTruck, FaChartLine, FaBell, FaBullseye, FaTag,
  FaShieldAlt, FaUsers, FaDatabase, FaHandshake,
  FaCashRegister, FaMoneyBillWave, FaSignOutAlt,
  FaGraduationCap, FaRobot, FaChevronDown, FaTimes, FaGift
} from 'react-icons/fa';

const MENU = [
  {
    seccion: 'Principal',
    abierto: true,
    items: [
      { ruta: '/dashboard',  icono: <FaChartBar />,   label: 'Dashboard' },
      { ruta: '/alertas',    icono: <FaBell />,       label: 'Alertas' },
      { ruta: '/asistente',  icono: <FaRobot />,      label: 'Asistente IA' },
    ]
  },
  {
    seccion: 'Finanzas',
    abierto: true,
    items: [
      { ruta: '/ingresos',     icono: <FaArrowUp />,     label: 'Ingresos' },
      { ruta: '/gastos',       icono: <FaArrowDown />,   label: 'Gastos' },
      { ruta: '/comprobantes', icono: <FaFileInvoice />, label: 'Comprobantes' },
      { ruta: '/proveedores',  icono: <FaTruck />,       label: 'Proveedores' },
      { ruta: '/reportes',     icono: <FaChartLine />,   label: 'Reportes' },
    ]
  },
  {
    seccion: 'Administración',
    abierto: false,
    items: [
      { ruta: '/presupuestos', icono: <FaBullseye />,   label: 'Presupuestos' },
      { ruta: '/categorias',   icono: <FaTag />,        label: 'Categorías' },
      { ruta: '/usuarios',     icono: <FaUsers />,      label: 'Usuarios' },
      { ruta: '/auditoria',    icono: <FaShieldAlt />,  label: 'Auditoría' },
      { ruta: '/backup',       icono: <FaDatabase />,   label: 'Backup' },
    ]
  },
  {
    seccion: 'Planillas',
    abierto: false,
    items: [
      { ruta: '/planillas/empleados', icono: <FaUsers />,         label: 'Empleados' },
      { ruta: '/planillas/nomina',    icono: <FaMoneyBillWave />, label: 'Nómina' },
      { ruta: '/planillas/beneficios',  icono: <FaGift />,          label: 'Beneficios' },
      { ruta: '/honorarios',          icono: <FaHandshake />,     label: 'Honorarios' },
      { ruta: '/caja-chica',          icono: <FaCashRegister />,  label: 'Caja Chica' },
    ]
  },
  {
    seccion: 'Contabilidad',
    abierto: false,
    items: [
      { ruta: '/balance-contador',      icono: <FaChartBar />,    label: 'Balance' },
      { ruta: '/comprobantes-contador', icono: <FaFileInvoice />, label: 'Comprobantes' },
    ]
  },
];

export default function Sidebar({ onClose }) {
  const { usuario, logout } = useAuth();
  const navigate  = useNavigate();
  const location  = useLocation();

  const [abiertos, setAbiertos] = useState(() =>
    MENU.reduce((acc, g) => ({ ...acc, [g.seccion]: g.abierto }), {})
  );

  const toggleSeccion = (seccion) => {
    setAbiertos(prev => ({ ...prev, [seccion]: !prev[seccion] }));
  };

  const handleLogout = async () => {
    await logout();
    navigate('/login');
    if (onClose) onClose();
  };

  const iniciales = usuario
    ? `${usuario.nombre?.[0]||''}${usuario.apellido?.[0]||''}`.toUpperCase()
    : 'U';

  const nombreCompleto = usuario
    ? `${usuario.nombre||''} ${usuario.apellido||''}`.trim()
    : 'Usuario';

  return (
    <aside className="sidebar">

      {/* ── Logo + botón cerrar ── */}
      <div className="sidebar-logo" style={{ justifyContent:'space-between' }}>
        <div style={{ display:'flex', alignItems:'center', gap:13 }}>
          <div className="sidebar-logo-icon">
            <FaGraduationCap />
          </div>
          <div className="sidebar-logo-text">
            <span className="sidebar-logo-title">EduFinanciero</span>
            <span className="sidebar-logo-sub">SIADEF · ADMIN</span>
          </div>
        </div>
        {/* Botón X para cerrar */}
        <button
          onClick={onClose}
          style={{
            background:'rgba(255,255,255,0.08)', border:'none',
            color:'rgba(255,255,255,0.6)', width:28, height:28,
            borderRadius:6, cursor:'pointer', flexShrink:0,
            display:'flex', alignItems:'center', justifyContent:'center',
            transition:'all .2s',
          }}
          onMouseEnter={e => { e.currentTarget.style.background='rgba(255,255,255,0.16)'; e.currentTarget.style.color='#fff'; }}
          onMouseLeave={e => { e.currentTarget.style.background='rgba(255,255,255,0.08)'; e.currentTarget.style.color='rgba(255,255,255,0.6)'; }}
          title="Cerrar menú"
        >
          <FaTimes size={12} />
        </button>
      </div>

      {/* ── Navegación con acordeón ── */}
      <nav className="sidebar-nav">
        {MENU.map((grupo) => {
          const estaAbierto = abiertos[grupo.seccion] ||
            grupo.items.some(i => location.pathname.startsWith(i.ruta));

          return (
            <div key={grupo.seccion}>
              <button
                onClick={() => toggleSeccion(grupo.seccion)}
                style={{
                  display:'flex', alignItems:'center', justifyContent:'space-between',
                  width:'100%', padding:'18px 14px 6px',
                  background:'none', border:'none', cursor:'pointer',
                  fontSize:10, fontWeight:700, letterSpacing:2,
                  color:'rgba(255,255,255,0.4)', textTransform:'uppercase',
                  fontFamily:'inherit', transition:'color .2s',
                }}
                onMouseEnter={e => e.currentTarget.style.color='rgba(255,255,255,0.65)'}
                onMouseLeave={e => e.currentTarget.style.color='rgba(255,255,255,0.4)'}
              >
                <span>{grupo.seccion}</span>
                <FaChevronDown size={9} style={{ transition:'transform .22s ease', transform: estaAbierto?'rotate(0deg)':'rotate(-90deg)', opacity:0.5 }} />
              </button>

              <div style={{ overflow:'hidden', maxHeight: estaAbierto?`${grupo.items.length*52}px`:'0px', transition:'max-height 0.28s ease' }}>
                {grupo.items.map((item) => (
                  <NavLink
                    key={item.ruta}
                    to={item.ruta}
                    onClick={onClose}
                    className={({ isActive }) => `sidebar-item${isActive ? ' active' : ''}`}
                    style={{ marginBottom:2 }}
                  >
                    <span className="sidebar-icon">{item.icono}</span>
                    {item.label}
                  </NavLink>
                ))}
              </div>

              <div style={{ height:1, background:'rgba(255,255,255,0.06)', margin:'6px 14px 0' }} />
            </div>
          );
        })}
      </nav>

      {/* ── Footer usuario ── */}
      <div className="sidebar-footer">
        <div className="sidebar-user">
          <div className="sidebar-user-avatar">{iniciales}</div>
          <div className="sidebar-user-info" style={{ flex:1, minWidth:0 }}>
            <div className="sidebar-user-name" style={{ overflow:'hidden', textOverflow:'ellipsis', whiteSpace:'nowrap' }}>
              {nombreCompleto}
            </div>
            <span className="sidebar-user-role">{usuario?.rol}</span>
          </div>
          <button
            onClick={handleLogout}
            title="Cerrar sesión"
            style={{
              background:'rgba(255,255,255,0.08)', border:'none',
              color:'rgba(255,255,255,0.55)', width:28, height:28,
              borderRadius:6, cursor:'pointer',
              display:'flex', alignItems:'center', justifyContent:'center',
              transition:'all .2s', flexShrink:0,
            }}
            onMouseEnter={e => { e.currentTarget.style.background='rgba(239,68,68,0.25)'; e.currentTarget.style.color='#fff'; }}
            onMouseLeave={e => { e.currentTarget.style.background='rgba(255,255,255,0.08)'; e.currentTarget.style.color='rgba(255,255,255,0.55)'; }}
          >
            <FaSignOutAlt size={12} />
          </button>
        </div>
      </div>
    </aside>
  );
}